import { Flex, Text } from "@mantine/core";
import { IconInfoCircleFilled } from "@tabler/icons-react";

interface InputErrorMessageProps {
  message?: React.ReactNode;
}

export const InputErrorMessage = ({ message }: InputErrorMessageProps) => {
  if (!message) return null;

  return (
    <Flex
      component="span"
      align={"center"}
      gap={6}
      mt={4}
      c={"var(--mantine-color-red-6)"}
      fw={500}>
      <IconInfoCircleFilled
        size={14}
        style={{ flexShrink: 0 }}
      />
      <Text
        fz={10}
        span>
        {message}
      </Text>
    </Flex>
  );
};
